// import { useContext, useEffect, useRef, useState } from "react";
// import { useLocation } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import { ConfigContext } from "../../Context/ConfigContext";
// import { useParams } from "react-router-dom";
// import { OverlayLoader, Spinner } from "../../Components/Shimmers";
// import slugify from "slugify";
// import Carousel from "react-multi-carousel";
// import 'react-multi-carousel/lib/styles.css';
// import { Helmet } from "react-helmet";
// import UniCarSearch from "../Cars/UniCarSearch";
// import PartsHorizontalCard from "../../Components/Cards/PartsHorizontalCard";
// import axios from "axios";
// import OEBrandsCarousel from "./PartsComponent/OEBrandsCarousol";
// import { axiosGet } from "../../Apis/axiosMethods";
// import { default_image } from "../../Imgaes";



// const NoCarSelected = () => {
//   const { currency, business_type } = useContext(ConfigContext);

//   const pc_id = localStorage.getItem("pc_id");
//   const location = useLocation();
//   const { t } = useTranslation();
//   const locale = localStorage.getItem("lang") ?? "en";
//   const dir = localStorage.getItem("dir");
//   const { STR_ID, STR_NODE_NAME } = useParams();

//   const [loading, setLoading] = useState(true);

//   const [parts, setParts] = useState([]);
//   const [brands, setBrands] = useState([]);
//   const [selectedBrands, setSelectedBrands] = useState([]);
//   const [selectedBrandTags, setSelectedBrandTags] = useState([]);

//   const [TotalParts, setTotalParts] = useState(0);

//   const [limit] = useState(50);
//   const [TotalPages, setTotalPages] = useState(0);
//   const [page, setPage] = useState(1);

//   const [title, setTitle] = useState("Ghayar");

//   const [isSticky, setSticky] = useState(false);

//   const [next, setNext] = useState(false)
//   const [prev, setPrev] = useState(false)

//   const [selectedBrandsArray, setSelectedBrandsArray] = useState([]);
//   const [selectedOEBrandsArray, setSelectedOEBrandsArray] = useState([]);

//   const [isUpdate, setIsUpdate] = useState(false)

//   const [oeBrands, setOEBrands] = useState([]);


//   const [positions, setPositions] = useState([]);
//   const [selectedPositions, setSelectedPositions] = useState([]);

//   const [responsive] = useState({
//     desktop: {
//       breakpoint: { max: 3000, min: 1024 },
//       items: 10,
//       slidesToSlide: 3,
//     },
//     tablet: {
//       breakpoint: { max: 1024, min: 464 },
//       items: 4,
//       slidesToSlide: 2,
//     },
//     mobile: {
//       breakpoint: { max: 464, min: 0 },
//       items: 3,
//       slidesToSlide: 1,
//     },
//   });

//   const [loadMore, setLoadMore] = useState(false);
//   const loadMoreRef = useRef(null);
//   const queryParams = new URLSearchParams(location.search);
//   const selectedPTID = queryParams.get('group');

//   useEffect(() => {
//     const fetchBrands = async () => {
//       try {
//         const response = await axiosGet(`/Parts/GetBrandsNoCar`, {
//           pc_id: localStorage.getItem("pc_id"),
//           str_id: STR_ID,
//           lang: locale,
//           currency: currency,
//           limit: limit,
//           page: 1,
//           pt_id: selectedPTID,
//           brands: selectedBrands,
//         }
//         );
//         if (response?.data?.success) {
//           const data = response.data;

//           setBrands(data.data || []);

//         }
//       } catch (error) {
//         console.error("Error fetching brands:", error);
//         setBrands([]);
//       }
//     };

//     fetchBrands();
//   }, [location]);

//   useEffect(() => {
//     const fetchPositions = async () => {
//       try {
//         const response = await axiosGet(`/Parts/GetPositionByDepartmentNoCar`,
//           {
//             str_id: STR_ID,
//             limit,
//             page,
//             brands: selectedBrands,
//           }
//         );

//         setPositions(response?.data?.data || []);
//       } catch (error) {
//         console.error("Error fetching positions:", error);
//         setPositions([]);
//       }
//     };

//     fetchPositions();
//   }, [STR_ID, limit, page, selectedBrands]);

//   useEffect(() => {
//     setSelectedBrands([]);
//     setSelectedBrandsArray([]);
//     setSelectedBrandTags([]);
//     setSelectedPositions([]);
//   }, [location.pathname]);

//   const hasMounted = useRef(false);

//   const isLoadMoreRef = useRef(false);

//   // Modify your useEffect
//   useEffect(() => {
//     if (hasMounted.current) {
//       if (!isLoadMoreRef.current) {
//         LoadParts(page);
//       }
//       isLoadMoreRef.current = false;
//     } else {
//       hasMounted.current = true;
//     }
//   }, [selectedBrandTags, selectedPositions, location, selectedOEBrandsArray]);

//   const LoadParts = async (pageNumber = page) => {
//     try {
//       setLoading(true);

//       const response = await axiosGet(`/Parts/${pc_id ? 'GetDepartmentPartsByWithCars' : 'GetDepartmentPartsByWithoutCars'}`, {
//         str_id: STR_ID,
//         lang: locale ?? "en",
//         currency: currency ?? "aed",
//         limit,
//         page: pageNumber,
//         pt_id: selectedPTID,
//         brands: selectedBrands,
//         selectedBrands: selectedBrandsArray
//           ? JSON.stringify(selectedBrandsArray)
//           : "",
//         selectedPositions: selectedPositions
//           ? JSON.stringify(selectedPositions)
//           : "",
//         type: business_type,
//         selectedOEBrands: selectedOEBrandsArray ? JSON.stringify(selectedOEBrandsArray) : "",
//         pc_id
//       }
//       );
//       const rawParts = response?.data?.data || [];
//       setParts(rawParts);

//       setTotalPages(response?.data?.total_pages);
//       setTotalParts(response?.data?.total_records);
//       setPage(response?.data?.page);
//       setPrev(response?.data?.prev);
//       setNext(response?.data?.next);

//     } catch (error) {
//       console.error("Fetch error:", error);
//     } finally {
//       setLoading(false);
//       setLoadMore(false);
//     }
//   };

//   const LoadMoreParts = async () => {
//     if (page >= TotalPages) return;

//     const nextPage = page + 1;

//     try {
//       setLoadMore(true);
//       isLoadMoreRef.current = true;

//       const response = await axiosGet(`/Parts/${pc_id ? 'GetDepartmentPartsByWithCars' : 'GetDepartmentPartsByWithoutCars'}`,
//         {
//           str_id: STR_ID,
//           lang: locale ?? "en",
//           currency: currency ?? "aed",
//           limit,
//           page: nextPage,
//           pt_id: selectedPTID,
//           selectedBrands: selectedBrandsArray?.length
//             ? JSON.stringify(selectedBrandsArray)
//             : "",
//           selectedPositions: selectedPositions?.length
//             ? JSON.stringify(selectedPositions)
//             : "",
//           selectedOEBrands: selectedOEBrandsArray?.length
//             ? JSON.stringify(selectedOEBrandsArray)
//             : "",
//           type: business_type,
//           pc_id
//         }
//       );

//       setParts((prev) => [...prev, ...(response?.data?.data || [])]);
//       setPage(nextPage);

//     } catch (error) {
//       console.error("Load more error:", error);
//     } finally {
//       setLoadMore(false);
//     }
//   };

//   const togglePosition = (Position) => {
//     setSelectedOEBrandsArray([]);
//     setSelectedPositions((prevSelectedPositions) => {
//       if (prevSelectedPositions.includes(Position)) {
//         return [];
//       } else {
//         return [Position];
//       }
//     });
//   };

//   const toggleBrand = (SUP_ID, SUP_BRAND, ART_TYPE) => {
//     setSelectedBrands((prevSelectedBrands) => {
//       if (prevSelectedBrands.includes(SUP_ID)) {
//         return prevSelectedBrands.filter((id) => id !== SUP_ID);
//       } else {
//         return [...prevSelectedBrands, SUP_ID];
//       }
//     });

//     setSelectedOEBrandsArray([]);

//     setSelectedBrandsArray((prevArray) => {
//       const index = prevArray.findIndex((item) => item.SUP_ID === SUP_ID);
//       if (index === -1) {
//         var clearBrand = SUP_BRAND;
//         const newArray = [...prevArray, { SUP_ID, SUP_BRAND, ART_TYPE }];
//         return newArray;
//       } else {
//         const newArray = prevArray.filter((item) => item.SUP_ID !== SUP_ID);
//         return newArray;
//       }
//     });

//     let setSelectedBTs = [...selectedBrandTags];
//     const index = selectedBrandTags.findIndex((tag) => tag.SUP_ID === SUP_ID);
//     if (index === -1) {
//       setSelectedBTs.push({ SUP_ID, SUP_BRAND, ART_TYPE });
//     } else {
//       setSelectedBTs.splice(index, 1);
//     }
//     setSelectedBrandTags(setSelectedBTs);
//     setPage(page);
//   };

//   const handlePageChange = (newPage) => {
//     if (newPage < 1 || newPage > TotalPages) return;

//     setPage(newPage);
//     LoadParts(newPage);

//     window.scrollTo({
//       top: 0,
//       behavior: "smooth",
//     });
//   };

//   const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
//     const { carouselState: { currentSlide } } = rest;
//     return (
//       <div className="carousel-button-group">
//         <button style={{ padding: '2px 6px', position: 'absolute', left: 0, top: '8px', marginLeft: '-40px' }} className={currentSlide === 0 ? 'btn btn-outline-dark btn-sm disable' : 'btn btn-outline-dark btn-sm '} onClick={() => previous()} > <i className="fas fa-chevron-left"></i> </button>
//         <button style={{ padding: '2px 6px', position: 'absolute', right: 0, top: '8px', marginRight: '-30px' }} className="btn btn-outline-dark btn-sm" onClick={() => next()} ><i className="fas fa-chevron-right"></i></button>
//       </div>
//     );
//   };

//   const BrandsTags = () => {
//     return parts && parts.length > 0 && selectedBrandTags && (
//       <div>
//         <h6 style={{ lineHeight: 0, marginTop: "10px" }}>
//           {selectedBrandTags.length !== 0 && t("selected_filters")}
//         </h6>
//         {selectedBrandTags && selectedBrandTags.map((item, index) => {
//           return (
//             <span
//               onClick={() =>
//                 toggleBrand(item.SUP_ID, item.SUP_BRAND)
//               }
//               className="badge badge-pill  mr-4 pt-2 pb-2"
//               style={{ backgroundColor: "#e9e9e9", cursor: "pointer" }}
//               key={`tags-${item.SUP_ID}`}
//             >
//               {item.SUP_BRAND}{" "}
//               <i className="fas fa-times-circle lightColorText" style={{ cursor: "pointer" }}></i>{" "}
//             </span>
//           );
//         })}
//       </div>
//     );
//   };

//   const BrandsOptions = () => {
//     var divs = <div style={{ position: 'relative' }} className={`prevent-select ${selectedBrandTags && selectedBrandTags.length !== 0 && 'mt-2'}`}>
//       <Carousel
//         arrows={false}
//         renderButtonGroupOutside={brands.length > 10}
//         customButtonGroup={<ButtonGroup />}
//         responsive={responsive}
//         swipeable={true}
//         draggable={true}
//         showDots={false}
//         infinite={false}
//         autoPlaySpeed={1000}
//         keyBoardControl={true}
//         customTransition="all .5"
//         transitionDuration={500}
//         containerClass="carousel-container"
//         dotListClass="custom-dot-list-style"
//         itemClass="carousel-item-padding-40-px">
//         {brands &&
//           [...brands]
//             .sort((a, b) => selectedBrands.includes(b.sup_id) - selectedBrands.includes(a.sup_id))
//             .map((img, index) => {
//               return (
//                 <div
//                   key={`img-sup-brand-${index}`}
//                   onClick={() => {
//                     toggleBrand(
//                       img.sup_id,
//                       img.sup_brand.trim().replace(/[\r\n]/g, '').replace(/&/g, '__AMP__'),
//                       'IAM'
//                     );
//                     window.scrollTo(0, 0);
//                   }}
//                   style={{
//                     cursor: 'pointer',
//                     height: '40px',
//                     width: '80px',
//                     textAlign: 'center',
//                     border: selectedBrands.includes(img.sup_id)
//                       ? '2px solid #cc000b'
//                       : '0px solid #CCC',
//                   }}
//                 >
//                   <ImageWithFallback
//                     src={`${img.logo_url}`}
//                     alt={img.sup_brand}
//                     index={index}
//                     fallbackText={img.sup_brand}
//                     OE={false}
//                   />
//                 </div>
//               );
//             })}
//       </Carousel>
//     </div>
//     return divs;
//   };

//   useEffect(() => {
//     const handleScroll = () => {
//       const offset = window.scrollY;
//       if (offset > 200) {
//         setSticky(true);
//       } else {
//         setSticky(false);
//       }
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => {
//       window.removeEventListener('scroll', handleScroll);
//     };
//   }, []);

//   useEffect(() => {
//     try {
//       setTitle(STR_NODE_NAME.replaceAll('-', ' ').replaceAll('_', ' ').replaceAll('  ', ' ').replaceAll('  ', ' ').trim());
//     } catch (err) {
//       setTitle('Ghayar');
//     }
//   }, [location]);

//   useEffect(() => {
//     const fetchOEBrands = async () => {
//       try {
//         if (!STR_ID) return;

//         const pcId = localStorage.getItem("pc_id");

//         const url = pcId ? `/Parts/GetOEBrandsWithCar` : `/Dashboard/GetOEBrandsByNoCar`;

//         const strIdValue = Array.isArray(STR_ID) ? STR_ID[0] : STR_ID;

//         const params = {
//           str_id: strIdValue,
//         };

//         if (pcId) {
//           params.pc_id = pcId;
//         }

//         const response = await axiosGet(url, params);

//         if (response?.data?.success) {
//           setOEBrands(response.data.data || []);
//         } else {
//           setOEBrands([]);
//         }
//       } catch (error) {
//         console.error("Error fetching OE Brands:", error);
//         setOEBrands([]);
//       }
//     };

//     fetchOEBrands();
//   }, [STR_ID]);

//   const getPageNumbers = () => {

//     const pages = [];
//     const firstVisible = 10;

//     // If total pages <= 10 => show all
//     if (TotalPages <= firstVisible) {
//       for (let i = 1; i <= TotalPages; i++) {
//         pages.push(i);
//       }
//       return pages;
//     }

//     // Always show first 10 pages
//     for (let i = 1; i <= firstVisible; i++) {
//       pages.push(i);
//     }

//     // Show dots if needed
//     if (page > firstVisible + 2) {
//       pages.push("...");
//     }

//     // Show middle pages near current page
//     let start = Math.max(firstVisible + 1, page - 1);
//     let end = Math.min(TotalPages - 1, page + 1);

//     for (let i = start; i <= end; i++) {
//       if (!pages.includes(i)) {
//         pages.push(i);
//       }
//     }

//     // Show dots before last page
//     if (end < TotalPages - 1) {
//       pages.push("...");
//     }

//     // Always show last page
//     pages.push(TotalPages);

//     return pages;
//   };

//   return (
//     <>
//       {
//         loading ?
//           <div style={{ height: "100vh" }}>
//             <OverlayLoader />
//           </div>
//           :
//           <div
//             className="header-bottom  d-none d-lg-block"
//             style={{
//               borderBottom: "1px solid rgb(226, 226, 226)",
//               marginBottom: "10px",
//             }}>
//             <Helmet>
//               <title>{title}</title>
//             </Helmet>
//             <div className="container">
//               <nav
//                 className="main-nav w-100"
//                 style={{ textAlign: dir === "rtl" ? "right" : "left" }}>
//                 <div className="row justify-content-center">
//                   <div className="col-md-3">
//                     <UniCarSearch redirectURL={`/Spare-Parts/${title}-${STR_ID}`} />
//                   </div>
//                   <div className="col-md-9">
//                     <h2 className="mt-2" style={{ color: '#132530', fontFamily: 'Montserrat, Arial, sans-serif', fontSize: '22px', fontWeight: '500', lineHeight: '24px' }}>
//                       {title}
//                     </h2>

//                     <div style={isSticky ? {
//                       position: 'fixed',
//                       top: '0',
//                       backgroundColor: '#FFF',
//                       width: '100%',
//                       left: '0',
//                       padding: '10px 50px',
//                       boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//                       zIndex: 10000000
//                     } : {}}>

//                       {isSticky ? (
//                         <div className="row">
//                           <div className="col-4" style={{
//                             color: '#59666e',
//                             fontFamily: 'Montserrat, Arial, sans-serif',
//                             fontSize: '12px',
//                             fontWeight: '500',
//                             lineHeight: '2',
//                             display: 'flex',
//                             alignItems: 'center',
//                             width: '100%',
//                             paddingRight: '3%'
//                           }}>
//                           </div>

//                           <div className="col-8">
//                             <div className="mb-2">
//                               {Array.isArray(brands) && brands.length > 0 && <BrandsOptions />}
//                             </div>

//                             <OEBrandsCarousel
//                               brandsData={oeBrands}
//                               setSelectedOEBrandsArray={setSelectedOEBrandsArray}
//                               selectedOEBrandsArray={selectedOEBrandsArray}
//                               setPage={setPage}
//                               setAFMSelectedBrands={setSelectedBrands}
//                               setSelectedBrandsArray={setSelectedBrandsArray}
//                               isSticky={isSticky}
//                               setSelectedBrandTags={setSelectedBrandTags}
//                             />
//                           </div>
//                         </div>
//                       ) : (
//                         <div className={dir === 'rtl' ? "pr-5" : 'pl-5'}>
//                           {brands.length > 0 && (
//                             <h5 className="text-muted">Aftermarket Brands</h5>
//                           )}

//                           {Array.isArray(brands) && brands.length > 0 && <BrandsTags />}
//                           {Array.isArray(brands) && brands.length > 0 && <BrandsOptions />}

//                           <div className="mt-2">
//                             <OEBrandsCarousel
//                               brandsData={oeBrands}
//                               setSelectedOEBrandsArray={setSelectedOEBrandsArray}
//                               selectedOEBrandsArray={selectedOEBrandsArray}
//                               setPage={setPage}
//                               setAFMSelectedBrands={setSelectedBrands}
//                               setSelectedBrandsArray={setSelectedBrandsArray}
//                               isSticky={isSticky}
//                               setSelectedBrandTags={setSelectedBrandTags}
//                             />
//                           </div>
//                         </div>
//                       )}

//                     </div>

//                     <div className="row">
//                       {positions && positions.length > 0 &&
//                         <div className="col-lg-12 mt-2">
//                           <span style={{ fontWeight: 500 }}>Fitting Position</span>
//                           <div className="mt-2" style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
//                             {positions.map((position, index) => (
//                               <div
//                                 key={index}
//                                 style={{
//                                   display: "flex",
//                                   alignItems: "center",
//                                   gap: "15px",
//                                   background: "#f8f9fa",
//                                   borderRadius: "10px",
//                                   padding: "8px 8px",
//                                   minWidth: "220px",
//                                   border: selectedPositions.includes(position.position) ? "2px solid #007bff" : "none",
//                                   cursor: "pointer"
//                                 }}
//                                 onClick={() => togglePosition(position.position)}
//                               >
//                                 {/* Image */}
//                                 <img
//                                   src={position.image}
//                                   alt={position.position}
//                                   style={{ width: "60px", height: "auto", objectFit: "contain" }}
//                                 />

//                                 {/* Position name */}
//                                 <span style={{ fontSize: "12px", fontWeight: "500", color: "#0d1f2a" }}>
//                                   {position.position}
//                                 </span>
//                               </div>
//                             ))}
//                           </div>
//                         </div>
//                       }

//                       <div className="container pt-5">
//                         {Array.isArray(parts) && parts.length > 0 && t('total_items', { total: TotalParts ? TotalParts : 0 })}
//                       </div>
//                       <div className="row pb-4">
//                         {parts.length > 0 ? parts.map((part, index) => {
//                           const productSlug = slugify(
//                             (part?.PRODUCT_GROUP || part?.ART_PRODUCT_NAME || "-")
//                               .replace(/,/g, "")
//                               .toLowerCase()
//                           );

//                           const OE_part_slug = slugify(`${productSlug}`.toLowerCase()) +
//                             "-" +
//                             slugify(`${part.ART_SEARCH_NUMBER}`.toLowerCase())
//                             + `/${part?.ART_SUP_BRAND}`
//                             ;

//                           const part_slug = `${productSlug}-${part.ART_SEARCH_NUMBER}-${part?.ART_SUP_ID}`

//                           const partImg = part.MEDIA_SOURCE ? `${part.MEDIA_SOURCE}` : default_image;

//                           return (
//                             <div><PartsHorizontalCard
//                               key={`r-part-id-${part.ART_ID}-${index}`}
//                               partImg={partImg}
//                               criteria={part.ARTICLE_CRITERIA_JSON}
//                               url={part.ART_TYPE === 'OENumber' ? `/OE-Spare-Parts/Details/${OE_part_slug}` : `/Spare-Parts/Details/${part_slug}`}
//                               id={part.ART_ID}
//                               title={part.PRODUCT_GROUP ?? part?.ART_PRODUCT_NAME}
//                               number={part.ART_ARTICLE_NR}
//                               price={business_type === 1 ? Number(part?.VD_BG_PRICE ?? 0).toFixed(2) : Number(part?.VD_BB_PRICE ?? 0).toFixed(2)}
//                               display_price={part.display_price ?? 0}
//                               mrp={`${part.VD_PRICE_MRP}` ?? `${part?.stock_price_mrp}` ?? 0}
//                               display_price_mrp={part.display_price_mrp ?? 0}
//                               qty={part.VD_QTY}
//                               imgUrl={partImg}
//                               action={true}
//                               brand={part.stock_brand_name}
//                               suplogo={part.SUP_LOGO_NAME}
//                               supid={part.SUP_ID}
//                               redLabel={3 === 3 ? `Aftermarket` : "Genuine"}
//                               partInfo={part.ART_INFO}
//                               pt_intl={part.PT_INTL}
//                               art_type={part.ART_TYPE}
//                               mfa_id={part.E_MFA_ID}
//                               part={part}

//                               SUP_WARRANTY={part?.SUP_WARRANTY}
//                               stock_delivery_days={part?.stock_delivery_days}

//                             /></div>
//                           );
//                         })
//                           :
//                           <div className="col-sm-12 col-6 d-flex justify-content-center align-items-center" style={{ marginLeft: "100px" }}>
//                             <div className="card out-of-stock-card">
//                               <div className="out-of-stock-icon">
//                                 <i className="fas fa-exclamation-circle"></i>
//                               </div>

//                               <div className="out-of-stock-title">
//                                 Temporarily Out of Stock
//                               </div>

//                               <div className="out-of-stock-text">
//                                 This part is currently unavailable and will be restocked soon.
//                                 Our team is updating inventory to make it available shortly.
//                                 <br /><br />
//                                 Thank you for your patience. Please check back again soon for updates.
//                               </div>
//                             </div>

//                             <style>
//                               {`
//       .out-of-stock-card {
//         border: 1px solid #e0e0e0;
//         border-left: 6px solid #ff4b4b;   /* LEFT BORDER ADDED */
//         border-radius: 12px;
//         padding: 35px 30px;
//         background: #ffffff;
//         box-shadow: 0px 4px 14px rgba(0,0,0,0.07);
//         text-align: center;
//         max-width: 650px;
//         margin: 50px auto;
//         font-family: 'Montserrat', Arial, sans-serif;
//       }

//       .out-of-stock-icon {
//         font-size: 50px;
//         color: #ff4b4b;
//         margin-bottom: 15px;
//       }

//       .out-of-stock-title {
//         font-size: 22px;
//         font-weight: 600;
//         color: #0d1f2a;
//         margin-bottom: 12px;
//       }

//       .out-of-stock-text {
//         font-size: 15px;
//         color: #4a5a67;
//         line-height: 1.7;
//         max-width: 500px;
//         margin: 0 auto;
//       }
//     `}
//                             </style>
//                           </div>
//                         }
//                       </div>
//                     </div>

//                     {loadMore && (
//                       <div className="text-center mt-2 mb-2 d-flex justify-content-center">
//                         <Spinner />
//                       </div>
//                     )}

//                     <div className="col-lg-12">

//                       {/* Load More */}
//                       {TotalPages > 1 && (
//                         <div className="text-center mb-2">
//                           <button
//                             type="button"
//                             disabled={loadMore}
//                             className="btn btn-dark pl-5 pr-5 pt-3 pb-3"
//                             style={{ fontSize: "12px" }}
//                             onClick={(e) => {
//                               e.preventDefault();
//                               LoadMoreParts();
//                             }}
//                           >
//                             <i className="fas fa-redo mr-2"></i>
//                             {loadMore ? "Loading..." : t("load_more")}
//                           </button>
//                         </div>
//                       )}
//                       {console.log({ TotalPages })}
//                       {/* Pagination */}
//                       {TotalPages > 1 &&
//                         <div className="d-flex justify-content-center align-items-center mt-4 flex-wrap gap-3">

//                           {/* Pagination */}
//                           <nav>
//                             <ul className="selected-pagination">

//                               {/* Prev */}
//                               <li
//                                 className={`selected-page-btn ${page === 1 ? "disabled" : ""}`}
//                                 onClick={() => page > 1 && handlePageChange(page - 1)}
//                               >
//                                 ‹
//                               </li>

//                               {/* Page Numbers */}
//                               {getPageNumbers().map((p, index) => (
//                                 <li
//                                   key={index}
//                                   className={`selected-page-btn ${p === page ? "active" : ""
//                                     } ${p === "..." ? "dots" : ""}`}
//                                   onClick={() => p !== "..." && handlePageChange(p)}
//                                 >
//                                   {p}
//                                 </li>
//                               ))}

//                               {/* Next */}
//                               <li
//                                 className={`selected-page-btn ${page === TotalPages ? "disabled" : ""}`}
//                                 onClick={() => page < TotalPages && handlePageChange(page + 1)}
//                               >
//                                 ›
//                               </li>

//                             </ul>
//                           </nav>
//                         </div>
//                       }


//                       <style>
//                         {
//                           `
//     .selected-pagination {
//   display: flex;
//   list-style: none;
//   padding: 0;
//   gap: 10px;
// }

// .selected-page-btn {
//   width: 46px;
//   height: 46px;
//   border-radius: 12px;
//   border: 2px solid #e5e5e5;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   font-size: 18px;
//   font-weight: 600;
//   color: #333;
//   cursor: pointer;
//   background: #fff;
//   transition: all 0.2s ease;
// }

// .selected-page-btn:hover:not(.active):not(.disabled):not(.dots) {
//   border-color: #cc000b;
//   color: #cc000b;
// }

// .selected-page-btn.active {
//   background: #cc000b;
//   color: #fff;
//   border-color: #cc000b;
// }

// .selected-page-btn.disabled {
//   opacity: 0.4;
//   pointer-events: none;
// }

// .selected-page-btn.dots {
//   cursor: default;
//   font-size: 22px;
//   border: none;
// }

// /* Results text */
// .results-text {
//   font-size: 16px;
//   font-weight: 500;
//   color: #333;
// }

// /* Page size dropdown */
// .page-size-select {
//   border-radius: 14px;
//   padding: 10px 16px;
//   border: none;
//   background: #f1f1f3;
//   font-size: 16px;
//   font-weight: 600;
//   cursor: pointer;
// }

//     `
//                         }
//                       </style>

//                     </div>


//                   </div>
//                 </div>
//               </nav>
//             </div>
//           </div>
//       }
//     </>
//   );
// };

// const ImageWithFallback = ({ src, index, alt, fallbackText, OE }) => {
//   const [imgError, setImgError] = useState(false);

//   const handleError = () => {
//     setImgError(true);
//   };

//   const fallbackStyle = {
//     textAlign: "center",
//     fontSize: "10px",
//     padding: "10px",
//     wordBreak: "break-word",
//     maxWidth: "90%",
//   };

//   const containerStyle = {
//     position: "relative",
//     width: "100%",
//     height: "30px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//   };

//   return (
//     <div style={containerStyle}>
//       {imgError ? (
//         <div style={fallbackStyle}>{fallbackText}</div>
//       ) : (
//         <img
//           draggable="false"
//           style={{
//             height: "30px",
//             margin: "auto",
//             float: "none",
//             marginTop: OE === false ? "5px" : 0,
//           }}
//           key={`img-part-${index}`}
//           src={src}
//           alt={alt}
//           onError={handleError}
//         />
//       )}
//     </div>
//   );
// };

// export default NoCarSelected;



import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ConfigContext } from "../../Context/ConfigContext";
import { OverlayLoader, Spinner } from "../../Components/Shimmers";
import slugify from "slugify";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Helmet } from "react-helmet";
import UniCarSearch from "../Cars/UniCarSearch";
import PartsHorizontalCard from "../../Components/Cards/PartsHorizontalCard";
import OEBrandsCarousel from "./PartsComponent/OEBrandsCarousol";
import { axiosGet } from "../../Apis/axiosMethods";
import { default_image } from "../../Imgaes";

const NoCarSelected = () => {
  const { currency, business_type } = useContext(ConfigContext);

  const pc_id = localStorage.getItem("pc_id");
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const locale = localStorage.getItem("lang") ?? "en";
  const dir = localStorage.getItem("dir");
  const { STR_ID, STR_NODE_NAME } = useParams();

  const queryParams = new URLSearchParams(location.search);
  const selectedPTID = queryParams.get("group");
  const pageFromUrl = Number(queryParams.get("page")) || 1;

  const [loading, setLoading] = useState(true);

  const [parts, setParts] = useState([]);
  const [brands, setBrands] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedBrandTags, setSelectedBrandTags] = useState([]);

  const [TotalParts, setTotalParts] = useState(0);

  const [limit] = useState(50);
  const [TotalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(pageFromUrl);

  const [title, setTitle] = useState("Ghayar");

  const [isSticky, setSticky] = useState(false);

  const [next, setNext] = useState(false);
  const [prev, setPrev] = useState(false);

  const [selectedBrandsArray, setSelectedBrandsArray] = useState([]);
  const [selectedOEBrandsArray, setSelectedOEBrandsArray] = useState([]);

  const [isUpdate, setIsUpdate] = useState(false);

  const [oeBrands, setOEBrands] = useState([]);

  const [positions, setPositions] = useState([]);
  const [selectedPositions, setSelectedPositions] = useState([]);

  const [responsive] = useState({
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 10,
      slidesToSlide: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 4,
      slidesToSlide: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 3,
      slidesToSlide: 1,
    },
  });

  const [loadMore, setLoadMore] = useState(false);
  const isLoadMoreRef = useRef(false);
  const isUrlSyncRef = useRef(false);
  const didInitialLoadRef = useRef(false);

  /* ------------------------------------------------------------------ */
  /*  URL <-> page sync                                                  */
  /* ------------------------------------------------------------------ */
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const currentUrlPage = Number(params.get("page")) || 1;
    if (currentUrlPage === page) return;

    if (page === 1) params.delete("page");
    else params.set("page", page);

    isUrlSyncRef.current = true;
    navigate({ search: params.toString() }, { replace: true });
  }, [page, navigate, location.search]);

  /* ------------------------------------------------------------------ */
  /*  Initial / structural data load                                     */
  /* ------------------------------------------------------------------ */
  useEffect(() => {
    // Skip the run that was triggered by our own `?page=` update
    if (isUrlSyncRef.current) {
      isUrlSyncRef.current = false;
      return;
    }

    const targetPage = didInitialLoadRef.current ? page : pageFromUrl;

    const id = setTimeout(() => {
      didInitialLoadRef.current = true;
      if (!isLoadMoreRef.current) {
        LoadParts(targetPage);
      }
      isLoadMoreRef.current = false;
    }, 0);

    return () => clearTimeout(id);
    // `?page=` intentionally excluded — we don't want to re-fetch
    // when the URL sync itself writes the page back.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBrandTags, selectedPositions, selectedOEBrandsArray, STR_ID, selectedPTID]);

  /* ------------------------------------------------------------------ */
  /*  Brands                                                             */
  /* ------------------------------------------------------------------ */
  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await axiosGet(`/Parts/GetBrandsNoCar`, {
          pc_id: localStorage.getItem("pc_id"),
          str_id: STR_ID,
          lang: locale,
          currency: currency,
          limit: limit,
          page: 1,
          pt_id: selectedPTID,
          brands: selectedBrands,
        });
        if (response?.data?.success) {
          setBrands(response.data.data || []);
        }
      } catch (error) {
        console.error("Error fetching brands:", error);
        setBrands([]);
      }
    };

    fetchBrands();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, selectedPTID]);

  /* ------------------------------------------------------------------ */
  /*  Positions                                                          */
  /* ------------------------------------------------------------------ */
  useEffect(() => {
    const fetchPositions = async () => {
      try {
        const response = await axiosGet(`/Parts/GetPositionByDepartmentNoCar`, {
          str_id: STR_ID,
          limit,
          page,
          brands: selectedBrands,
        });
        setPositions(response?.data?.data || []);
      } catch (error) {
        console.error("Error fetching positions:", error);
        setPositions([]);
      }
    };

    fetchPositions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [STR_ID, limit, selectedBrands]);

  /* ------------------------------------------------------------------ */
  /*  Reset filters when the route changes                               */
  /* ------------------------------------------------------------------ */
  useEffect(() => {
    setSelectedBrands([]);
    setSelectedBrandsArray([]);
    setSelectedBrandTags([]);
    setSelectedPositions([]);
  }, [location.pathname]);

  /* ------------------------------------------------------------------ */
  /*  OE brands                                                          */
  /* ------------------------------------------------------------------ */
  useEffect(() => {
    const fetchOEBrands = async () => {
      try {
        if (!STR_ID) return;

        const pcId = localStorage.getItem("pc_id");
        const url = pcId
          ? `/Parts/GetOEBrandsWithCar`
          : `/Dashboard/GetOEBrandsByNoCar`;
        const strIdValue = Array.isArray(STR_ID) ? STR_ID[0] : STR_ID;
        const params = { str_id: strIdValue };
        if (pcId) params.pc_id = pcId;

        const response = await axiosGet(url, params);
        if (response?.data?.success) {
          setOEBrands(response.data.data || []);
        } else {
          setOEBrands([]);
        }
      } catch (error) {
        console.error("Error fetching OE Brands:", error);
        setOEBrands([]);
      }
    };

    fetchOEBrands();
  }, [STR_ID]);

  /* ------------------------------------------------------------------ */
  /*  Sticky header                                                      */
  /* ------------------------------------------------------------------ */
  useEffect(() => {
    const handleScroll = () => setSticky(window.scrollY > 200);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  /* ------------------------------------------------------------------ */
  /*  Title                                                              */
  /* ------------------------------------------------------------------ */
  useEffect(() => {
    try {
      setTitle(
        STR_NODE_NAME.replaceAll("-", " ")
          .replaceAll("_", " ")
          .replaceAll("  ", " ")
          .replaceAll("  ", " ")
          .trim()
      );
    } catch (err) {
      setTitle("Ghayar");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  /* ------------------------------------------------------------------ */
  /*  Data loaders                                                       */
  /* ------------------------------------------------------------------ */
  const LoadParts = async (pageNumber = page) => {
    try {
      setLoading(true);

      const response = await axiosGet(
        `/Parts/${pc_id
          ? "GetDepartmentPartsByWithCars"
          : "GetDepartmentPartsByWithoutCars"
        }`,
        {
          str_id: STR_ID,
          lang: locale ?? "en",
          currency: currency ?? "aed",
          limit,
          page: pageNumber,
          pt_id: selectedPTID,
          brands: selectedBrands,
          selectedBrands: selectedBrandsArray
            ? JSON.stringify(selectedBrandsArray)
            : "",
          selectedPositions: selectedPositions
            ? JSON.stringify(selectedPositions)
            : "",
          type: business_type,
          selectedOEBrands: selectedOEBrandsArray
            ? JSON.stringify(selectedOEBrandsArray)
            : "",
          pc_id,
        }
      );

      const rawParts = response?.data?.data || [];
      setParts(rawParts);

      setTotalPages(response?.data?.total_pages);
      setTotalParts(response?.data?.total_records);
      setPage(response?.data?.page);
      setPrev(response?.data?.prev);
      setNext(response?.data?.next);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
      setLoadMore(false);
    }
  };

  const LoadMoreParts = async () => {
    if (page >= TotalPages) return;

    const nextPage = page + 1;

    try {
      setLoadMore(true);
      isLoadMoreRef.current = true;

      const response = await axiosGet(
        `/Parts/${pc_id
          ? "GetDepartmentPartsByWithCars"
          : "GetDepartmentPartsByWithoutCars"
        }`,
        {
          str_id: STR_ID,
          lang: locale ?? "en",
          currency: currency ?? "aed",
          limit,
          page: nextPage,
          pt_id: selectedPTID,
          selectedBrands: selectedBrandsArray?.length
            ? JSON.stringify(selectedBrandsArray)
            : "",
          selectedPositions: selectedPositions?.length
            ? JSON.stringify(selectedPositions)
            : "",
          selectedOEBrands: selectedOEBrandsArray?.length
            ? JSON.stringify(selectedOEBrandsArray)
            : "",
          type: business_type,
          pc_id,
        }
      );

      setParts((prevParts) => [...prevParts, ...(response?.data?.data || [])]);
      setPage(nextPage);
    } catch (error) {
      console.error("Load more error:", error);
    } finally {
      setLoadMore(false);
    }
  };

  /* ------------------------------------------------------------------ */
  /*  Handlers                                                           */
  /* ------------------------------------------------------------------ */
  const togglePosition = (Position) => {
    setSelectedOEBrandsArray([]);
    setSelectedPositions((prevSelectedPositions) => {
      if (prevSelectedPositions.includes(Position)) return [];
      return [Position];
    });
  };

  const toggleBrand = (SUP_ID, SUP_BRAND, ART_TYPE) => {
    setSelectedBrands((prevSelectedBrands) => {
      if (prevSelectedBrands.includes(SUP_ID)) {
        return prevSelectedBrands.filter((id) => id !== SUP_ID);
      }
      return [...prevSelectedBrands, SUP_ID];
    });

    setSelectedOEBrandsArray([]);

    setSelectedBrandsArray((prevArray) => {
      const index = prevArray.findIndex((item) => item.SUP_ID === SUP_ID);
      if (index === -1) {
        return [...prevArray, { SUP_ID, SUP_BRAND, ART_TYPE }];
      }
      return prevArray.filter((item) => item.SUP_ID !== SUP_ID);
    });

    const setSelectedBTs = [...selectedBrandTags];
    const index = selectedBrandTags.findIndex((tag) => tag.SUP_ID === SUP_ID);
    if (index === -1) {
      setSelectedBTs.push({ SUP_ID, SUP_BRAND, ART_TYPE });
    } else {
      setSelectedBTs.splice(index, 1);
    }
    setSelectedBrandTags(setSelectedBTs);
    setPage(page);
  };

  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > TotalPages) return;
    setPage(newPage);
    LoadParts(newPage);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  /* ------------------------------------------------------------------ */
  /*  Pagination helpers                                                 */
  /* ------------------------------------------------------------------ */
  const getPageNumbers = () => {
    const pages = [];
    const firstVisible = 10;

    if (TotalPages <= firstVisible) {
      for (let i = 1; i <= TotalPages; i++) pages.push(i);
      return pages;
    }

    for (let i = 1; i <= firstVisible; i++) pages.push(i);

    if (page > firstVisible + 2) pages.push("...");

    const start = Math.max(firstVisible + 1, page - 1);
    const end = Math.min(TotalPages - 1, page + 1);

    for (let i = start; i <= end; i++) {
      if (!pages.includes(i)) pages.push(i);
    }

    if (end < TotalPages - 1) pages.push("...");

    pages.push(TotalPages);
    return pages;
  };

  /* ------------------------------------------------------------------ */
  /*  Sub-components                                                     */
  /* ------------------------------------------------------------------ */
  const ButtonGroup = ({ next, previous, ...rest }) => {
    const { carouselState: { currentSlide }, } = rest;
    return (
      <div className="carousel-button-group">
        <button
          style={{
            padding: "2px 6px",
            position: "absolute",
            left: 0,
            top: "8px",
            marginLeft: "-40px",
          }}
          className={currentSlide === 0 ? "btn btn-outline-dark btn-sm disable" : "btn btn-outline-dark btn-sm "}
          onClick={() => previous()}
        >
          <i className="fas fa-chevron-left"></i>
        </button>
        <button
          style={{
            padding: "2px 6px",
            position: "absolute",
            right: 0,
            top: "8px",
            marginRight: "-30px",
          }}
          className="btn btn-outline-dark btn-sm"
          onClick={() => next()}
        >
          <i className="fas fa-chevron-right"></i>
        </button>
      </div>
    );
  };

  const BrandsTags = () => {
    if (!parts || parts.length === 0) return null;
    if (!selectedBrandTags) return null;

    return (
      <div>
        <h6 style={{ lineHeight: 0, marginTop: "10px" }}>
          {selectedBrandTags.length !== 0 && t("selected_filters")}
        </h6>
        {selectedBrandTags.map((item) => (
          <span
            onClick={() => toggleBrand(item.SUP_ID, item.SUP_BRAND)}
            className="badge badge-pill mr-4 pt-2 pb-2"
            style={{ backgroundColor: "#e9e9e9", cursor: "pointer" }}
            key={`tags-${item.SUP_ID}`}
          >
            {item.SUP_BRAND}{" "}
            <i
              className="fas fa-times-circle lightColorText"
              style={{ cursor: "pointer" }}
            ></i>{" "}
          </span>
        ))}
      </div>
    );
  };

  const BrandsOptions = () => (
    <div
      style={{ position: "relative" }}
      className={`prevent-select ${selectedBrandTags && selectedBrandTags.length !== 0 && "mt-2"
        }`}
    >
      <Carousel
        arrows={false}
        renderButtonGroupOutside={brands.length > 10}
        customButtonGroup={<ButtonGroup />}
        responsive={responsive}
        swipeable
        draggable
        showDots={false}
        infinite={false}
        autoPlaySpeed={1000}
        keyBoardControl
        customTransition="all .5"
        transitionDuration={500}
        containerClass="carousel-container"
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-40-px"
      >
        {brands &&
          [...brands]
            .sort(
              (a, b) =>
                selectedBrands.includes(b.sup_id) -
                selectedBrands.includes(a.sup_id)
            )
            .map((img, index) => (
              <div
                key={`img-sup-brand-${index}`}
                onClick={() => {
                  toggleBrand(
                    img.sup_id,
                    img.sup_brand
                      .trim()
                      .replace(/[\r\n]/g, "")
                      .replace(/&/g, "__AMP__"),
                    "IAM"
                  );
                  window.scrollTo(0, 0);
                }}
                style={{
                  cursor: "pointer",
                  height: "40px",
                  width: "80px",
                  textAlign: "center",
                  border: selectedBrands.includes(img.sup_id)
                    ? "2px solid #cc000b"
                    : "0px solid #CCC",
                }}
              >
                <ImageWithFallback
                  src={`${img.logo_url}`}
                  alt={img.sup_brand}
                  index={index}
                  fallbackText={img.sup_brand}
                  OE={false}
                />
              </div>
            ))}
      </Carousel>
    </div>
  );

  /* ------------------------------------------------------------------ */
  /*  Render                                                             */
  /* ------------------------------------------------------------------ */
  return (
    <>
      {loading ? (
        <div style={{ height: "100vh" }}>
          <OverlayLoader />
        </div>
      ) : (
        <div
          className="header-bottom d-none d-lg-block"
          style={{
            borderBottom: "1px solid rgb(226, 226, 226)",
            marginBottom: "10px",
          }}
        >
          <Helmet>
            <title>{title}</title>
          </Helmet>

          <div className="container">
            <nav
              className="main-nav w-100"
              style={{ textAlign: dir === "rtl" ? "right" : "left" }}
            >
              <div className="row justify-content-center">
                <div className="col-md-3">
                  <UniCarSearch
                    redirectURL={`/Spare-Parts/${title}-${STR_ID}`}
                  />
                </div>

                <div className="col-md-9">
                  <h2
                    className="mt-2"
                    style={{
                      color: "#132530",
                      fontFamily: "Montserrat, Arial, sans-serif",
                      fontSize: "22px",
                      fontWeight: "500",
                      lineHeight: "24px",
                    }}
                  >
                    {title}
                  </h2>

                  <div
                    style={
                      isSticky
                        ? {
                          position: "fixed",
                          top: "0",
                          backgroundColor: "#FFF",
                          width: "100%",
                          left: "0",
                          padding: "10px 50px",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                          zIndex: 10000000,
                        }
                        : {}
                    }
                  >
                    {isSticky ? (
                      <div className="row">
                        <div
                          className="col-4"
                          style={{
                            color: "#59666e",
                            fontFamily: "Montserrat, Arial, sans-serif",
                            fontSize: "12px",
                            fontWeight: "500",
                            lineHeight: "2",
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                            paddingRight: "3%",
                          }}
                        ></div>

                        <div className="col-8">
                          <div className="mb-2">
                            {Array.isArray(brands) && brands.length > 0 && (
                              <BrandsOptions />
                            )}
                          </div>

                          <OEBrandsCarousel
                            brandsData={oeBrands}
                            setSelectedOEBrandsArray={setSelectedOEBrandsArray}
                            selectedOEBrandsArray={selectedOEBrandsArray}
                            setPage={setPage}
                            setAFMSelectedBrands={setSelectedBrands}
                            setSelectedBrandsArray={setSelectedBrandsArray}
                            isSticky={isSticky}
                            setSelectedBrandTags={setSelectedBrandTags}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className={dir === "rtl" ? "pr-5" : "pl-5"}>
                        {brands.length > 0 && (
                          <h5 className="text-muted">Aftermarket Brands</h5>
                        )}

                        {Array.isArray(brands) && brands.length > 0 && (
                          <BrandsTags />
                        )}
                        {Array.isArray(brands) && brands.length > 0 && (
                          <BrandsOptions />
                        )}

                        <div className="mt-2">
                          <OEBrandsCarousel
                            brandsData={oeBrands}
                            setSelectedOEBrandsArray={setSelectedOEBrandsArray}
                            selectedOEBrandsArray={selectedOEBrandsArray}
                            setPage={setPage}
                            setAFMSelectedBrands={setSelectedBrands}
                            setSelectedBrandsArray={setSelectedBrandsArray}
                            isSticky={isSticky}
                            setSelectedBrandTags={setSelectedBrandTags}
                          />
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="row">
                    {positions && positions.length > 0 && (
                      <div className="col-lg-12 mt-2">
                        <span style={{ fontWeight: 500 }}>Fitting Position</span>
                        <div
                          className="mt-2"
                          style={{
                            display: "flex",
                            gap: "20px",
                            flexWrap: "wrap",
                          }}
                        >
                          {positions.map((position, index) => (
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "15px",
                                background: "#f8f9fa",
                                borderRadius: "10px",
                                padding: "8px 8px",
                                minWidth: "220px",
                                border: selectedPositions.includes(
                                  position.position
                                )
                                  ? "2px solid #007bff"
                                  : "none",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                togglePosition(position.position)
                              }
                            >
                              <img
                                src={position.image}
                                alt={position.position}
                                style={{
                                  width: "60px",
                                  height: "auto",
                                  objectFit: "contain",
                                }}
                              />
                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "500",
                                  color: "#0d1f2a",
                                }}
                              >
                                {position.position}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    <div className="container pt-5">
                      {Array.isArray(parts) &&
                        parts.length > 0 &&
                        t("total_items", {
                          total: TotalParts ? TotalParts : 0,
                        })}
                    </div>

                    <div className="row pb-4">
                      {parts.length > 0 ? (
                        parts.map((part, index) => {
                          const productSlug = slugify(
                            (
                              part?.PRODUCT_GROUP ||
                              part?.ART_PRODUCT_NAME ||
                              "-"
                            )
                              .replace(/,/g, "")
                              .toLowerCase()
                          );

                          const OE_part_slug =
                            slugify(`${productSlug}`.toLowerCase()) +
                            "-" +
                            slugify(`${part.ART_SEARCH_NUMBER}`.toLowerCase()) +
                            `/${part?.ART_SUP_BRAND}`;

                          const part_slug = `${productSlug}-${part.ART_SEARCH_NUMBER}-${part?.ART_SUP_ID}`;

                          const partImg = part.MEDIA_SOURCE
                            ? `${part.MEDIA_SOURCE}`
                            : default_image;

                          return (
                            <div key={`r-part-id-${part.ART_ID}-${index}`}>
                              <PartsHorizontalCard
                                partImg={partImg}
                                criteria={part.ARTICLE_CRITERIA_JSON}
                                url={
                                  part.ART_TYPE === "OENumber"
                                    ? `/OE-Spare-Parts/Details/${OE_part_slug}`
                                    : `/Spare-Parts/Details/${part_slug}`
                                }
                                id={part.ART_ID}
                                title={
                                  part.PRODUCT_GROUP ?? part?.ART_PRODUCT_NAME
                                }
                                number={part.ART_ARTICLE_NR}
                                price={
                                  business_type === 1
                                    ? Number(part?.VD_BG_PRICE ?? 0).toFixed(2)
                                    : Number(part?.VD_BB_PRICE ?? 0).toFixed(2)
                                }
                                display_price={part.display_price ?? 0}
                                mrp={
                                  `${part.VD_PRICE_MRP}` ??
                                  `${part?.stock_price_mrp}` ??
                                  0
                                }
                                display_price_mrp={part.display_price_mrp ?? 0}
                                qty={part.VD_QTY}
                                imgUrl={partImg}
                                action={true}
                                brand={part.stock_brand_name}
                                suplogo={part.SUP_LOGO_NAME}
                                supid={part.SUP_ID}
                                redLabel="Aftermarket"
                                partInfo={part.ART_INFO}
                                pt_intl={part.PT_INTL}
                                art_type={part.ART_TYPE}
                                mfa_id={part.E_MFA_ID}
                                part={part}
                                SUP_WARRANTY={part?.SUP_WARRANTY}
                                stock_delivery_days={part?.stock_delivery_days}
                              />
                            </div>
                          );
                        })
                      ) : (
                        <div
                          className="col-sm-12 col-6 d-flex justify-content-center align-items-center"
                          style={{ marginLeft: "100px" }}
                        >
                          <div className="card out-of-stock-card">
                            <div className="out-of-stock-icon">
                              <i className="fas fa-exclamation-circle"></i>
                            </div>
                            <div className="out-of-stock-title">
                              Temporarily Out of Stock
                            </div>
                            <div className="out-of-stock-text">
                              This part is currently unavailable and will be
                              restocked soon. Our team is updating inventory to
                              make it available shortly.
                              <br />
                              <br />
                              Thank you for your patience. Please check back
                              again soon for updates.
                            </div>
                          </div>

                          <style>
                            {`
                              .out-of-stock-card {
                                border: 1px solid #e0e0e0;
                                border-left: 6px solid #ff4b4b;
                                border-radius: 12px;
                                padding: 35px 30px;
                                background: #ffffff;
                                box-shadow: 0px 4px 14px rgba(0,0,0,0.07);
                                text-align: center;
                                max-width: 650px;
                                margin: 50px auto;
                                font-family: 'Montserrat', Arial, sans-serif;
                              }
                              .out-of-stock-icon {
                                font-size: 50px;
                                color: #ff4b4b;
                                margin-bottom: 15px;
                              }
                              .out-of-stock-title {
                                font-size: 22px;
                                font-weight: 600;
                                color: #0d1f2a;
                                margin-bottom: 12px;
                              }
                              .out-of-stock-text {
                                font-size: 15px;
                                color: #4a5a67;
                                line-height: 1.7;
                                max-width: 500px;
                                margin: 0 auto;
                              }
                            `}
                          </style>
                        </div>
                      )}
                    </div>
                  </div>

                  {loadMore && (
                    <div className="text-center mt-2 mb-2 d-flex justify-content-center">
                      <Spinner />
                    </div>
                  )}

                  <div className="col-lg-12">
                    {/* Load More */}
                    {TotalPages > 1 && (
                      <div className="text-center mb-2">
                        <button
                          type="button"
                          disabled={loadMore}
                          className="btn btn-dark pl-5 pr-5 pt-3 pb-3"
                          style={{ fontSize: "12px" }}
                          onClick={(e) => {
                            e.preventDefault();
                            LoadMoreParts();
                          }}
                        >
                          <i className="fas fa-redo mr-2"></i>
                          {loadMore ? "Loading..." : t("load_more")}
                        </button>
                      </div>
                    )}

                    {/* Pagination */}
                    {TotalPages > 1 && (
                      <div className="d-flex justify-content-center align-items-center mt-4 flex-wrap gap-3 mb-3">
                        <nav>
                          <ul className="selected-pagination">
                            <li
                              className={`selected-page-btn ${page === 1 ? "disabled" : ""
                                }`}
                              onClick={() =>
                                page > 1 && handlePageChange(page - 1)
                              }
                            >
                              ‹
                            </li>

                            {getPageNumbers().map((p, index) => (
                              <li
                                key={index}
                                className={`selected-page-btn ${p === page ? "active" : ""
                                  } ${p === "..." ? "dots" : ""}`}
                                onClick={() =>
                                  p !== "..." && handlePageChange(p)
                                }
                              >
                                {p}
                              </li>
                            ))}

                            <li
                              className={`selected-page-btn ${page === TotalPages ? "disabled" : ""
                                }`}
                              onClick={() =>
                                page < TotalPages &&
                                handlePageChange(page + 1)
                              }
                            >
                              ›
                            </li>
                          </ul>
                        </nav>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
      )}
    </>
  );
};

const ImageWithFallback = ({ src, index, alt, fallbackText, OE }) => {
  const [imgError, setImgError] = useState(false);

  const handleError = () => setImgError(true);

  const fallbackStyle = {
    textAlign: "center",
    fontSize: "10px",
    padding: "10px",
    wordBreak: "break-word",
    maxWidth: "90%",
  };

  const containerStyle = {
    position: "relative",
    width: "100%",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  return (
    <div style={containerStyle}>
      {imgError ? (
        <div style={fallbackStyle}>{fallbackText}</div>
      ) : (
        <img
          draggable="false"
          style={{
            height: "30px",
            margin: "auto",
            float: "none",
            marginTop: OE === false ? "5px" : 0,
          }}
          key={`img-part-${index}`}
          src={src}
          alt={alt}
          onError={handleError}
        />
      )}
    </div>
  );
};

export default NoCarSelected;